import { RouteV2Id, SubscriberRouteV2Id } from 'routes/routesConfigV2';
import { SubChecklistCard } from 'types/electionService';

export const SUBSCRIBER_V2_CHECKLIST_MAPPING: Record<
  | SubChecklistCard.HEALTH_QUESTIONNAIRE
  | SubChecklistCard.IMQ_GENERAL_INFO
  | SubChecklistCard.IMQ_SUBSCRIBER_PROFILE
  | SubChecklistCard.IMQ_SUBSCRIBER_DEPENDENTS,
  SubscriberRouteV2Id
> = {
  [SubChecklistCard.HEALTH_QUESTIONNAIRE]: RouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE_ENTRY,
  [SubChecklistCard.IMQ_GENERAL_INFO]: RouteV2Id.SUBSCRIBER_EMPLOYMENT_DETAILS,
  [SubChecklistCard.IMQ_SUBSCRIBER_PROFILE]: RouteV2Id.SUBSCRIBER_IMQ_SUBSCRIBER_PROFILE,
  [SubChecklistCard.IMQ_SUBSCRIBER_DEPENDENTS]: RouteV2Id.SUBSCRIBER_IMQ_SUBSCRIBER_DEPENDENTS,
};

export function isSubscriberV2ChecklistCard(
  card: SubChecklistCard,
): card is keyof typeof SUBSCRIBER_V2_CHECKLIST_MAPPING {
  return card in SUBSCRIBER_V2_CHECKLIST_MAPPING;
}
